import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import { FiStar, FiSearch, FiMoreVertical, FiX, FiPlusSquare } from "react-icons/fi";
import UseToggle from "../../../Hooks/UseToggle";
import AddMemberInGroup from "./AddMemberInGroup";
import { bookmarkTeamProjectServices } from "../../../APIServices/WorkBridge/TeamManagement/bookmarkTeamProjectServices";
import { GoStarFill } from "react-icons/go";

const ChatHeader = ({ memberList, activeChannel, channelName, currentUserData, getBookmarkTeamProjectList }) => {
  const [showSearch, setShowSearch] = useState(false);
  const inputRef = useRef(null);
  const toggles = UseToggle();

  useEffect(() => {
    if (showSearch) inputRef.current?.focus();
  }, [showSearch]);

  const canAddMembers = Boolean(channelName?.gpId);

  const bookmarkManageTeamProject = async () => {
    let userData = {}
    userData.uniqueId = channelName?.userId || channelName?.gpId
    userData.type = channelName?.userId ? "team" : "groupProject"
    let data = await bookmarkTeamProjectServices.bookmarkManageTeamProject(userData)
    if (data?.statusCode === 200) {
      getBookmarkTeamProjectList()
    }
  }
  return (
    <>
      <div className="chat-header px-3">
        <div className="chat-header-left d-flex align-items-center gap-2">
          {channelName?.bookmarked ?
            <GoStarFill title="Remove Bookmark" className="text-warning CP" onClick={bookmarkManageTeamProject} />
            :
            <FiStar title="Add to Bookmark" className="text-white CP" onClick={bookmarkManageTeamProject} />
          }
          {channelName?.avatar && (
            <div className="position-relative">
              <img className="rounded-2 border" src={channelName.avatar} alt={channelName.name} style={{ height: 30 }} />
              <div
                className={
                  channelName.status === "online"
                    ? "text-success"
                    : channelName.status === "away"
                      ? "text-warning"
                      : "text-secondary small rounded-1"
                }
                style={{ position: "absolute", top: -12, right: -2 }}
              >
                <FaCircle style={{ fontSize: 8 }} />
              </div>
            </div>
          )}

          {!showSearch && <strong className="text-capitalize">{channelName?.name ?? channelName}</strong>}
        </div>

        <div className="chat-header-right d-flex align-items-center gap-2">
          {(channelName?.type === "private" && currentUserData?.roleType === "organization") &&
            <FiPlusSquare
              className="CP"
              title="Add Member"
              onClick={() => {
                if (!canAddMembers) return;
                toggles.setToggle();
              }}
            />
          }
          <div className={`search-wrapper ${showSearch ? "open" : ""}`}>
            {showSearch && (
              <>
                <div className={`position-relative`}>
                  <FiSearch className="position-absolute" style={{ top: 10, left: 18 }} />
                  <Form.Control
                    ref={inputRef}
                    type="search"
                    className="form-control-sm rounded-1 w-100 p-2 ps-5"
                    placeholder="Search..."
                    autoFocus
                    onBlur={() => setShowSearch(false)}
                    onKeyDown={(e) => e.key === "Escape" && setShowSearch(false)}
                    style={{ fontSize: 12 }}
                  />
                </div>
                <FiX className="CP ms-1" onClick={() => setShowSearch(false)} />
              </>
            )}
          </div>

          {!showSearch && <FiSearch className="CP" onClick={() => setShowSearch(true)} />}
          <FiMoreVertical className="CP" />
        </div>
      </div>

      <AddMemberInGroup
        memberList={memberList}
        activeChannel={activeChannel}
        currentUserData={currentUserData}
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add people to #${channelName?.name}`}
      />
    </>
  );
};

export default ChatHeader;


